import { disconnectComplainSlackChannel, IAlarmChannel } from "apis/meeting-room-complain/alarm-channel";
import { EmptyLow, IndexContainer, RowContainer, TableContainer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { useToast } from "hook/useToast";

type PersonTableViewProps = {
  channels?: IAlarmChannel[];
  onUpdate?: () => void;
  disabled?: boolean;
};

const SlackTableView = ({ channels = [], onUpdate, disabled }: PersonTableViewProps) => {
  const { showToast } = useToast();

  const onDeleteComplainManager = async (meetingComplainId: string, channelName: string) => {
    const res = await disconnectComplainSlackChannel(meetingComplainId);
    if (res.success) {
      showToast(`민원 슬랙 채널에서 "${channelName}"이 삭제되었습니다.`, "success");
      onUpdate?.();
    } else {
      showToast("슬랙 채널 삭제에 실패했습니다. 재시도해 주세요.", "error");
    }
  };
  return (
    <TableContainer>
      <IndexContainer>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{
            minWidth: "160px",
            maxWidth: "200px",
            flex: 1,
          }}
        >
          슬랙 워크스페이스
        </UI.Typography>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{
            flex: 1,
          }}
        >
          채널
        </UI.Typography>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{
            minWidth: "74px",
            maxWidth: "160px",
            flex: 1,
          }}
        >
          관리
        </UI.Typography>
      </IndexContainer>
      {channels.length === 0 ? (
        <EmptyLow>
          <UI.Icon name="addPerson" color="var(--alias-color-label-alternative)" size={24} />
          <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
            등록된 채널이 없습니다. 신속한 민원 처리를 위해 슬랙 채널을 추가해 주세요.
          </UI.Typography>
        </EmptyLow>
      ) : (
        channels.map((channel, index) => (
          <ManagerRow
            disabled={!channel.isActive}
            key={index}
            workspace={channel.slackWorkspaceName ?? ""}
            channelName={channel.slackChannelName}
            onDelete={() => {
              onDeleteComplainManager(channel.id, channel.slackChannelName);
            }}
          />
        ))
      )}
    </TableContainer>
  );
};

export default SlackTableView;

const ManagerRow = ({
  workspace,
  channelName,
  onDelete,
  disabled,
}: {
  workspace: string;
  channelName: string;
  disabled?: boolean;
  onDelete?: () => void;
}) => {
  return (
    <RowContainer>
      <div className="user">
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color={disabled ? "var(--alias-color-label-disabled" : "var(--alias-color-label-normal)"}
        >
          {workspace}
        </UI.Typography>
      </div>
      <div className="email">
        <UI.Typography
          type="label01"
          fontStyle="regular"
          color={disabled ? "var(--alias-color-label-disabled" : "var(--alias-color-label-normal)"}
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {channelName}
        </UI.Typography>
      </div>
      <div
        style={{
          minWidth: "74px",
          flex: 1,
          maxWidth: "160px",
        }}
      >
        <UI.Button
          title="삭제하기"
          type="outlined"
          primary={false}
          size="small"
          onClick={onDelete}
          disabled={disabled}
        />
      </div>
    </RowContainer>
  );
};
